export default "__VITE_ASSET__DZOaenRK__"